import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../services/api.service';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-make-i-bid',
  standalone: false,
  templateUrl: './make-i-bid.component.html',
  styleUrl: './make-i-bid.component.scss',
})
export class MakeIBidComponent implements OnInit, OnDestroy {
  @Output() routeConfig = new EventEmitter();
  @Output() generatePDFEmitter: EventEmitter<any> = new EventEmitter();
  @Output() stepCompleted = new EventEmitter<void>();
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
  @Input() schemeType: string;
  @Input() proposalName: any;
  @Input() id: any;
  @Input() format: any;
  @Input() proposalId: any;
  @Input() schemeId: any;
  @Input() url: String = '';
  proposalForm: FormGroup;
  challengeForm: FormGroup;
  userID: any;
  baseUrl = environment.APIUrl;
  private subscriptions = new Subscription();
  docuemntList: any;
  winners: any;
  uploadedFiles: any[] = [];

  constructor(
    private messageService: MessageService,
    private apiService: ApiService
  ) {
    const role = sessionStorage.getItem('user_role_id');
    this.userID = role;
  }

  payload: {
    proposal_id: any;
    proposal_name: any;
    schemeId: any;
  };

  ngOnInit() {
    // Get proposal details from inputs (same as upload-doc component)
    this.payload = {
      proposal_id: this.proposalId || this.stepDetails?.proposal,
      proposal_name: this.proposalName,
      schemeId: this.schemeId || this.stepDetails?.scheme
    };
    this.getData();
    console.log('Make-I Bid Component:', this.url, this.stepDetails, this.payload);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  getData() {
    // Use the same API as upload-doc component for Make-I
    const url = `/make1/shorlisting/da/?proposal_step__proposal=${this.payload.proposal_id}&proposal_step=${this.id}&scheme=${this.payload.schemeId}`;
    const sub = this.apiService.getAPI(url).subscribe((resp: any) => {
      this.docuemntList = resp;

      // Process the response same way as upload-doc component
      const vendorMap = new Map();

      Object.keys(resp).forEach((vendorName: string) => {
        const docs = resp[vendorName] || [];

        docs.forEach((doc: any) => {
          const vendorId = doc.da?.id || doc.vendor?.id;
          
          if (!vendorId) return;

          if (!vendorMap.has(vendorId)) {
            vendorMap.set(vendorId, {
              vendor: {
                id: vendorId,
                name: vendorName
              },
              vendor_status: null,
              documents: [],
              rawEntries: []
            });
          }

          const vendorEntry = vendorMap.get(vendorId);
          if (doc.document) {
            vendorEntry.documents.push({
              filePath: doc.document,
              fileName: doc.document.split('/').pop(),
            });
          }
          vendorEntry.rawEntries.push(doc);
        });
      });

      // Convert map to array
      this.winners = Array.from(vendorMap.values());
    });
    this.subscriptions.add(sub);
  }

  setStatus(vendor: any, status: 'Qualify' | 'Disqualify') {
    console.log(vendor);
    vendor.vendor_status = status;
    const formData = new FormData();
    formData.append('vendor_status', vendor.vendor_status);
    formData.append('vendor_eval_id', vendor.rawEntries[0].id);

    const sub = this.apiService
      .putAPI(`/make1/technical-evaluation/`, formData)
      .subscribe({
        next: (res: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Vendor updated successfully',
          });
          this.getData(); // refresh the table
        },
        error: (err) => {},
      });
    this.subscriptions.add(sub);
  }
}

